import { render, staticRenderFns } from "./InvitationCard.vue?vue&type=template&id=ffa2d974&scoped=true&"
import script from "./InvitationCard.vue?vue&type=script&lang=ts&"
export * from "./InvitationCard.vue?vue&type=script&lang=ts&"
import style0 from "./InvitationCard.vue?vue&type=style&index=0&id=ffa2d974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa2d974",
  null
  
)

export default component.exports